import React from 'react';
import PublicNav from '@/components/PublicNav';
import { ExternalLink } from 'lucide-react';

const PortfolioPage = () => {
  const projects = [
    {
      title: 'FinTech Dashboard',
      category: 'Web Application',
      image: 'https://images.unsplash.com/photo-1549791084-5f78368b208b',
      description: 'Real-time financial analytics platform with advanced charting'
    },
    {
      title: 'E-Commerce Platform',
      category: 'Online Store',
      image: 'https://images.unsplash.com/photo-1631109782087-2344fc513f7d',
      description: 'Modern shopping experience with seamless checkout'
    },
    {
      title: 'Healthcare Portal',
      category: 'Web Application',
      image: 'https://images.unsplash.com/photo-1758873268663-5a362616b5a7',
      description: 'HIPAA-compliant patient management system'
    },
    {
      title: 'Real Estate Marketplace',
      category: 'Platform',
      image: 'https://images.unsplash.com/photo-1758873271902-a63ecd5b5235',
      description: 'Property listings with virtual tours and instant booking'
    }
  ];

  return (
    <div className="min-h-screen bg-[#030712]">
      <PublicNav />
      
      <section className="pt-32 pb-20 px-6 md:px-12" data-testid="portfolio-hero">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-7xl font-bold font-['Syne'] text-white mb-6" data-testid="portfolio-title">
            Our <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 to-purple-400">Work</span>
          </h1>
          <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto" data-testid="portfolio-description">
            A selection of projects we've delivered for our exclusive clients.
          </p>
        </div>
      </section>

      <section className="pb-32 px-6 md:px-12" data-testid="portfolio-grid">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-2xl border border-white/10 hover:border-indigo-500/50 transition-all duration-500"
              data-testid={`portfolio-item-${index}`}
            >
              <div className="aspect-video overflow-hidden">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent flex flex-col justify-end p-8">
                <span className="text-indigo-400 text-sm font-medium mb-2">{project.category}</span>
                <h3 className="text-2xl font-bold font-['Syne'] text-white mb-2">{project.title}</h3>
                <p className="text-slate-300 text-sm mb-4">{project.description}</p>
                <button className="flex items-center space-x-2 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-sm font-medium">View Case Study</span>
                  <ExternalLink size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <footer className="border-t border-white/10 py-12 px-6" data-testid="footer">
        <div className="max-w-7xl mx-auto text-center text-slate-500">
          <p>&copy; 2026 DH HOME NETWORKING AND WEBSITES. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PortfolioPage;
